// Reusable presentational building blocks for editorial pages.
export function PageHeader({ eyebrow, title, intro, image, tall }) {
  return (
    <section className="relative dl-noise overflow-hidden border-b border-[rgba(198,167,106,0.15)]">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover" loading="eager" />
          <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(5,8,20,0.72) 0%, rgba(5,8,20,0.88) 60%, #050814 100%)" }} />
        </div>
      )}
      <div className={`dl-container relative z-10 ${tall ? "py-32 md:py-40" : "py-24 md:py-28"}`}>
        {eyebrow && <div className="dl-eyebrow mb-5 dl-fade">{eyebrow}</div>}
        <h1 className="serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F3E9D2] max-w-4xl dl-fade" style={{ animationDelay: ".1s" }}>
          {title}
        </h1>
        {intro && (
          <p className="mt-7 text-lg text-[#F3E9D2]/70 max-w-2xl leading-relaxed dl-fade" style={{ animationDelay: ".2s" }}>
            {intro}
          </p>
        )}
      </div>
    </section>
  );
}

export function Section({ children, className = "" }) {
  return <section className={`dl-container py-16 md:py-24 ${className}`}>{children}</section>;
}

export function SectionTitle({ eyebrow, title, center }) {
  return (
    <div className={`mb-12 ${center ? "text-center" : ""}`}>
      {eyebrow && <div className="dl-eyebrow mb-3">{eyebrow}</div>}
      <h2 className="serif text-3xl sm:text-4xl lg:text-5xl text-[#F3E9D2] leading-tight">{title}</h2>
    </div>
  );
}

export function Prose({ children }) {
  return <div className="prose-dl max-w-3xl space-y-5 text-[#F3E9D2]/80 leading-relaxed text-base md:text-[1.05rem]">{children}</div>;
}

export function Quote({ children }) {
  return (
    <blockquote className="serif text-2xl md:text-3xl italic text-[#D4B978] leading-snug border-l-2 border-[#C6A76A] pl-6 my-10 max-w-3xl">
      {children}
    </blockquote>
  );
}

export function Disclaimer({ children }) {
  return (
    <p className="text-sm text-[#F3E9D2]/55 italic border border-[rgba(198,167,106,0.2)] bg-[#0B1020] p-5 mt-8 max-w-3xl">
      {children}
    </p>
  );
}
